import { useMemo } from 'react'

import { OTA_TICKET_TYPES } from '@/constants/ticketTypes'
import { useFiltersContext } from '@/context'
import { DashboardQueries } from '@/graphql/queries/dashboard.queries'
import { TicketTypesQueries } from '@/graphql/queries/ticketTypes.queries'
import { TicketSectionData } from '@/types/Dashboard'
import { TicketType } from '@/types/TicketType'

import { useGraphql } from '../useGraphql'

const useTicketSection = () => {
  const [{ marketSegmentFilter }] = useFiltersContext()
  const { marketSegmentIds } = marketSegmentFilter

  // Fetch all ticket types
  const { data: typesData, isLoading: typesLoading } = useGraphql<{ ticketTypes: TicketType[] }>(
    TicketTypesQueries.QUERY_KEY,
    TicketTypesQueries.getTicketTypes(),
  )

  // Filter out OTA types to get non-OTA types
  const nonOtaTicketTypes = useMemo(() => {
    if (!typesData?.ticketTypes) return []
    return typesData.ticketTypes
      .map((t) => t.description)
      .filter((type) => !OTA_TICKET_TYPES.includes(type as (typeof OTA_TICKET_TYPES)[number]))
  }, [typesData?.ticketTypes])

  const ticketSectionQuery = useGraphql<{ agmDashboard: TicketSectionData }>(
    DashboardQueries.QUERY_KEYS.getTicketSection,
    DashboardQueries.getTicketSection(),
    {
      marketSegmentIds: marketSegmentIds,
      ticketTypes: nonOtaTicketTypes.length > 0 ? nonOtaTicketTypes : undefined,
    },
    {
      enabled: !!marketSegmentIds?.length,
    },
  )

  return {
    ...ticketSectionQuery,
    isLoading: typesLoading || ticketSectionQuery.isLoading,
    nonOtaTicketTypes,
  }
}

export default useTicketSection
